<template lang="pug">
  .component-driver-reservations
    .action-bar
      h2 Cards
    .tabs-inner-content
      base-list(:component="component", :dataLoader="dataLoader")
        header-columns(slot="before", :columns="headers")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import Card from "components/backoffice/Card";
  import BaseList from "../../../pages/backoffice/BaseList";
  import HeaderColumns from "../../structure/ui/HeaderColumns";

  export default {
    name: "DriverCards",
    components: {
      HeaderColumns,
      BaseList,
      Card,
    },
    data() {
      return {
        headers: ['Card name & ID', 'Driver', 'Chip id', 'Active'],
        component: require('components/backoffice/Card'),
      }
    },
    created() {

    },
    methods: {
      dataLoader(callback, page, resultsPerPage, search) {
        KeplerBackofficeSdk.clients.list(page, resultsPerPage, search).cards(this.$route.params.id, (data) => {
          callback(data)
        })
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  //.driver-licenses
    margin: 10px
</style>



// WEBPACK FOOTER //
// ClientCards.vue?59b5fd3a